import { isValidUrl } from "../../../../components/ui/inputs";
import { CompanyFormValues, ValidationFormErrors, ValidationFormsModeEnum } from "./types";

export function validateCompany(
  values: CompanyFormValues,
  mode: ValidationFormsModeEnum,
  original?: CompanyFormValues
): ValidationFormErrors {
  const errors: ValidationFormErrors = {};

  if (!values.name || values.name.trim() === "") {
    errors.name = "Назва обов’язкова.";
  }
  if (!values.site || !isValidUrl(values.site!)) {
    errors.site = "Введіть коректний сайт.";
  }

  if (!values.type || values.type === "") {
    errors.stage = "Вкажіть тип компанії.";
  }

  if (!values.responsibleContact || values.responsibleContact.trim() === "") {
    errors.responsibleContact = "Вкажіть представника.";
  }

  if (mode === "edit" && original) {

  }

  return errors;
}
